// extracted by mini-css-extract-plugin
export var hidden = "_49-1";
export var leftPanel = "_49-2";
export var readonlyInspector = "_49-3";
export var rightPanel = "_49-0";